
import { defineComponent } from 'vue'
import { buildProps, definePropType } from '@/utils/props'
import type { IKeysProps } from '@/utils/types'
import TreeOrgNode from '@/components/node'
const cloneorgProps = buildProps({
  data: {
    type: Object,
    required: true
  },
  props: {
    type: definePropType<IKeysProps>(Object)
  },
  modelValue: Boolean,
  horizontal: Boolean,
  selectedKey: String,
  collapsable: Boolean,
  renderContent: Function,
  labelStyle: Object,
  labelClassName: {
    type: [Function, String]
  }
} as const)
export default defineComponent({
  components: {
    TreeOrgNode: TreeOrgNode
  },
  props: cloneorgProps,
  setup (props, ctx) {
    const defaultSlot = !!ctx.slots.default
    const expandSlot = !!ctx.slots.expand
    return {
      defaultSlot,
      expandSlot
    }
  }
})
